/* unplugin-vue-components disabled */import script from "./InterestingCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./InterestingCourse.vue?vue&type=script&setup=true&lang=js"

import "./InterestingCourse.vue?vue&type=style&index=0&id=351ffcdd&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户山农大-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-351ffcdd"]])

export default __exports__